import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { TooltipProvider, Toaster } from '@ui/components';
import { SessionProvider } from '@shared/global/session';
import { ContentProvider } from '@shared/global/content';
import { LanguageProvider } from '@shared/global/i18n';
import { RouterProvider } from 'react-router-dom';
import { useScript } from '@shared/hooks';
import { router } from '@core/router';
import { JSX } from 'react';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retryDelay: 1000, retry: 3 } },
});

function App(): JSX.Element {
  useScript(import.meta.env.VITE_PAYU_SCRIPT_URL);

  return (
    <SessionProvider>
      <LanguageProvider>
        <QueryClientProvider client={queryClient}>
          <TooltipProvider>
            <ContentProvider>
              <RouterProvider router={router} />
              <Toaster position="top-right" />
            </ContentProvider>
          </TooltipProvider>
        </QueryClientProvider>
      </LanguageProvider>
    </SessionProvider>
  );
}

export default App;
